/**
 * @desc: - 面板- 横向紧贴，带展示图片，URL链接
 * @param  {[STRING]} className     [顶层样式类]
 * @param  {[ARRAY]}  displaySet    [导航类名集合] - [{className: 'pt', url: '', title: ''}]
 * @author: klaf
 */
import React from 'react';
import { connect } from 'react-redux';
import KGameModal from '../KGameModal';
class FullWidthLinkPic extends React.Component {

  constructor(props) {
    super(props);
    this.state={
        domainName:false,
        kgamemodal:false
    }
    this.openTransfer =this.openTransfer.bind(this);
    this.setGame = this.setGame.bind(this);
  }
  componentDidMount() {
    // 获取余额
    this.props.$$USER.getPlatformBalance('pt');
    this.props.$$USER.getPlatformBalance('ag');
    this.props.$$USER.getPlatformBalance('bbin');
    this.props.$$USER.getPlatformBalance('wali');
    this.props.$$USER.getPlatformBalance('yy');
    this.props.$$USER.getPlatformBalance('kgame');
    this.setState({
      domainName:window.location.hostname.indexOf('hengy800')!==-1
    })
  }
  // 进入游戏
  enterGame = (url, platform) => {
    platform = _.toLower(platform);
    const __user = this.props.__USER.toJS();
    if (__user.platform_profile[platform].code == 30300) {
      this.props.$$BASE.openToast('您未开通！请联系您的上级');
      return false;
    }
    if (!__user.platform_profile[platform].onload) {
      this.props.$$BASE.openToast('平台数据加载中，请稍后...');
      return false;
    }
    if(platform === 'kgame'){
      return this.setState({kgamemodal: true});
    }
    window.open(url);
  }
  // 直接进入平台 
  openTransfer(platfrom,url){
    let __url = (platfrom==='WALI' || platfrom==='YY' || platfrom==='KGAME')? null : url;
    this.props.$$BASE.openOverlay();
    this.props.$$BASE.openTransferModal(platfrom,__url)
  }
  setGame(){
    const {displaySet, className} = this.props;
    const {domainName} = this.state
    return displaySet.map((item, index) =>{
      return <dd key={index} className={item.logo} style={{display:(domainName&&(item.title.indexOf('AG')!==-1))?'none':''}}>
        <p className='games_title'>{item.title}</p>
        {
          (item.platfrom==="WALI" || item.platfrom==="YY" || item.platfrom==="KGAME" )?<a onClick={() => this.enterGame(item.url, item.platfrom)}>立即游戏</a> : <a href={item.url}>立即游戏</a>
        }
        <span onClick={this.openTransfer.bind(this,item.platfrom,item.url)}>转账</span>
      </dd>
    })
  }
  // 关闭kgame游戏弹窗
  closeModal() {
    this.setState({kgamemodal: false})
  }
  render() {
    const {displaySet, className} = this.props;
    var dataOption = displaySet[0];

    return (
        <div className="nav-child">
          <div  className="nav-child-1080">
            <dl>
              <dt className={className}></dt>
              {
                this.setGame()
              }
            </dl>
          </div>
          {
            this.state.kgamemodal &&
            <KGameModal 
              frameSrc="/kgame/play"
              close={this.closeModal.bind(this)}
              transferFn={this.openTransfer.bind(this, "KGAME")}
            />
          }
        </div>
    );
  }
}
reactMixin(FullWidthLinkPic.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __USER: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullWidthLinkPic)